import {Icon, Menu} from 'antd';
import useUserGroups from 'hooks/useUserGroups';
import React from 'react';
import 'css/Navigation.less';

function EmployerNav(props) {
    const {initiallyCollapsed, ...restProps} = props;

    const [userGroups] = useUserGroups();

    return <Menu
        theme="dark"
        mode="inline"
        defaultOpenKeys={initiallyCollapsed ? [] : ['masterdata', 'management', 'veriflyt']}
        {...restProps}
    >
        <Menu.Item key="passengers">
            <Icon type="team"/>
            <span>Passengers</span>
        </Menu.Item>
        {userGroups.findIndex(g => g.includes('flytsuite.checkpoint')) > -1 && (
            <Menu.Item key="checkpoint">
                <Icon type="check-circle" />
                <span>CheckPoint</span>
            </Menu.Item>
        )}
        <Menu.SubMenu key="masterdata" className='mc-navigation-submenu-masterdata'
                      title={<span><Icon type="database"/><span>Master Data</span></span>}>
            <Menu.Item key="masterdata/personnel">Personnel</Menu.Item>
        </Menu.SubMenu>
        {userGroups.findIndex(g => g.includes('management') || g === 'flytsuite.master.all') > -1 &&
            <Menu.SubMenu className='mc-naviagation-submenu-management' key="management"
                          title={<span><Icon type="team"/><span>Management</span></span>}>
                {userGroups.findIndex(g => g.includes('management.all') || g.includes('management.emailtriggers.all') || g === 'flytsuite.master.all') > -1 && (
                    <Menu.Item key="management/email-triggers">Email Triggers</Menu.Item>
                )}
            </Menu.SubMenu>
        }
        {userGroups.includes('flytsuite.compliance.ticket.all') ? (
            <Menu.SubMenu key="veriflyt" className="mc-navigation-submenu-veriflyt"
                          title={<span><Icon type="check"/><span>VeriFlyt</span></span>}>
                <Menu.Item key="veriflyt/records">Records</Menu.Item>
            </Menu.SubMenu>
        ) : null}
    </Menu>
}

export default EmployerNav